'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MerchandiseIds$PRODU;

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

var MerchandiseIds = _interopRequireWildcard(_MerchandiseIds);

var _Marketing_Starter = require('bender-url!pricing-pages-unified-ui/img/productIcons/Marketing_Starter.svg');

var _Marketing_Starter2 = _interopRequireDefault(_Marketing_Starter);

var _Marketing_Pro = require('bender-url!pricing-pages-unified-ui/img/productIcons/Marketing_Pro.svg');

var _Marketing_Pro2 = _interopRequireDefault(_Marketing_Pro);

var _Marketing_Ent = require('bender-url!pricing-pages-unified-ui/img/productIcons/Marketing_Ent.svg');

var _Marketing_Ent2 = _interopRequireDefault(_Marketing_Ent);

var _Sales_Starter = require('bender-url!pricing-pages-unified-ui/img/productIcons/Sales_Starter.svg');

var _Sales_Starter2 = _interopRequireDefault(_Sales_Starter);

var _Sales_Pro = require('bender-url!pricing-pages-unified-ui/img/productIcons/Sales_Pro.svg');

var _Sales_Pro2 = _interopRequireDefault(_Sales_Pro);

var _Sales_Ent = require('bender-url!pricing-pages-unified-ui/img/productIcons/Sales_Ent.svg');

var _Sales_Ent2 = _interopRequireDefault(_Sales_Ent);

var _Service_Starter = require('bender-url!pricing-pages-unified-ui/img/productIcons/Service_Starter.svg');

var _Service_Starter2 = _interopRequireDefault(_Service_Starter);

var _Service_Pro = require('bender-url!pricing-pages-unified-ui/img/productIcons/Service_Pro.svg');

var _Service_Pro2 = _interopRequireDefault(_Service_Pro);

var _Service_Ent = require('bender-url!pricing-pages-unified-ui/img/productIcons/Service_Ent.svg');

var _Service_Ent2 = _interopRequireDefault(_Service_Ent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (_MerchandiseIds$PRODU = {}, _defineProperty(_MerchandiseIds$PRODU, MerchandiseIds.PRODUCT_MARKETING_STARTER_EMAIL, {
  title: 'pricing-pages.hubTiers.starter.title',
  icon: _Marketing_Starter2.default,
  includes: 'pricing-pages.merchandise.marketing-starter.includes',
  lowerTierPlus: 'pricing-pages.hubTiers.starter.lowerTierPlus'
}), _defineProperty(_MerchandiseIds$PRODU, MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL, {
  title: 'pricing-pages.hubTiers.professional.title',
  icon: _Marketing_Pro2.default,
  includes: 'pricing-pages.merchandise.marketing-professional.includes',
  lowerTierPlus: 'pricing-pages.hubTiers.professional.lowerTierPlus'
}), _defineProperty(_MerchandiseIds$PRODU, MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE, {
  title: 'pricing-pages.hubTiers.enterprise.title',
  icon: _Marketing_Ent2.default,
  includes: 'pricing-pages.merchandise.marketing-enterprise.includes',
  lowerTierPlus: 'pricing-pages.hubTiers.enterprise.lowerTierPlus'
}), _defineProperty(_MerchandiseIds$PRODU, MerchandiseIds.PRODUCT_SALES_STARTER, {
  title: 'pricing-pages.hubTiers.starter.title',
  icon: _Sales_Starter2.default,
  includes: 'pricing-pages.merchandise.sales-starter.includes',
  lowerTierPlus: 'pricing-pages.hubTiers.starter.lowerTierPlus'
}), _defineProperty(_MerchandiseIds$PRODU, MerchandiseIds.PRODUCT_SALES_PROFESSIONAL, {
  title: 'pricing-pages.hubTiers.professional.title',
  icon: _Sales_Pro2.default,
  includes: 'pricing-pages.merchandise.sales-professional.includes',
  lowerTierPlus: 'pricing-pages.hubTiers.professional.lowerTierPlus'
}), _defineProperty(_MerchandiseIds$PRODU, MerchandiseIds.PRODUCT_SALES_ENTERPRISE, {
  title: 'pricing-pages.hubTiers.enterprise.title',
  icon: _Sales_Ent2.default,
  includes: 'pricing-pages.merchandise.sales-enterprise.includes',
  lowerTierPlus: 'pricing-pages.hubTiers.enterprise.lowerTierPlus'
}), _defineProperty(_MerchandiseIds$PRODU, MerchandiseIds.PRODUCT_SERVICE_STARTER, {
  title: 'pricing-pages.hubTiers.starter.title',
  icon: _Service_Starter2.default,
  includes: 'pricing-pages.merchandise.service-starter.includes',
  lowerTierPlus: 'pricing-pages.hubTiers.starter.lowerTierPlus'
}), _defineProperty(_MerchandiseIds$PRODU, MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL, {
  title: 'pricing-pages.hubTiers.professional.title',
  icon: _Service_Pro2.default,
  includes: 'pricing-pages.merchandise.service-professional.includes',
  lowerTierPlus: 'pricing-pages.hubTiers.professional.lowerTierPlus'
}), _defineProperty(_MerchandiseIds$PRODU, MerchandiseIds.PRODUCT_SERVICE_ENTERPRISE, {
  title: 'pricing-pages.hubTiers.enterprise.title',
  icon: _Service_Ent2.default,
  includes: 'pricing-pages.merchandise.service-enterprise.includes',
  lowerTierPlus: 'pricing-pages.hubTiers.enterprise.lowerTierPlus'
}), _MerchandiseIds$PRODU);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/constants/HighlightedMerchHeaderConfig.js
// module id = 252
// module chunks = 3 4